var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuAppCenterSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8664_5367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70374 5.79111C5.70374 5.54339 5.80214 5.30583 5.9773 5.13067C6.15246 4.95551 6.39002 4.85711 6.63773 4.85711H10.3737C10.6214 4.85711 10.859 4.95551 11.0342 5.13067C11.2093 5.30583 11.3077 5.54339 11.3077 5.79111V9.52709C11.3077 9.7748 11.2093 10.0124 11.0342 10.1875C10.859 10.3627 10.6214 10.4611 10.3737 10.4611H6.63773C6.39002 10.4611 6.15246 10.3627 5.9773 10.1875C5.80214 10.0124 5.70374 9.7748 5.70374 9.52709V5.79111Z",
    fill: "white",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70374 14.3306C5.70374 14.0829 5.80214 13.8453 5.9773 13.6701C6.15246 13.495 6.39002 13.3966 6.63773 13.3966H10.3737C10.6214 13.3966 10.859 13.495 11.0342 13.6701C11.2093 13.8453 11.3077 14.0829 11.3077 14.3306V18.0666C11.3077 18.3143 11.2093 18.5518 11.0342 18.727C10.859 18.9022 10.6214 19.0006 10.3737 19.0006H6.63773C6.39002 19.0006 6.15246 18.9022 5.9773 18.727C5.80214 18.5518 5.70374 18.3143 5.70374 18.0666V14.3306Z",
    fill: "white",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2426 14.3306C14.2426 14.0829 14.341 13.8453 14.5162 13.6701C14.6913 13.495 14.9289 13.3966 15.1766 13.3966H18.9126C19.1603 13.3966 19.3979 13.495 19.573 13.6701C19.7482 13.8453 19.8466 14.0829 19.8466 14.3306V18.0666C19.8466 18.3143 19.7482 18.5518 19.573 18.727C19.3979 18.9022 19.1603 19.0006 18.9126 19.0006H15.1766C14.9289 19.0006 14.6913 18.9022 14.5162 18.727C14.341 18.5518 14.2426 18.3143 14.2426 18.0666V14.3306Z",
    fill: "white",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2426 7.6591H19.8466",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.045 4.85711V10.4611",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8664_5367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.846313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuAppCenterSelected);
export default __webpack_public_path__ + "static/media/ic-menu-app-center-selected.002c9266272425e6e084ebb4853aca13.svg";
export { ForwardRef as ReactComponent };